import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseTheme } from '../../../common/hooks/useTheme'
import { UseTypeFontSize } from '../../../common/hooks/useTypeFontSize'
import { Element } from '../../../common/html/element'
import { getStyle } from '../../../common/html/helper'
import { Icon } from '../../../common/html/icon'
import { Style } from '../../../common/html/Style'
import { TextEllipsisStaticLine } from '../../../common/textEllipsis/TextEllipsisStaticLine'
import { FORMAT, formatDateTime } from '../../../helpers/datetime'
import { selectEndDate, selectStartDate } from '../store/slice'
import classes from './RadioDateRangeCustom.module.scss'

export const RadioDateRangeCustom = ({
  title,
  value,
  activeValue,
  isCheckOnClickText,
  appendStyle,
  mlTitle,
  titleStyle,
  translateProps,
}) => {
  const typeFontSize = UseTypeFontSize()
  const theme = UseTheme()
  const locale = useSelector((state) => state.i18n.locale)
  const startDateFilter = useSelector(selectStartDate)
  const endDateFilter = useSelector(selectEndDate)

  const startDate = startDateFilter
    ? formatDateTime(startDateFilter, FORMAT.DATE, locale)
    : startDateFilter
  const endDate = endDateFilter
    ? formatDateTime(endDateFilter, FORMAT.DATE, locale)
    : endDateFilter

  const isCheck = activeValue === value

  return (
    <Element id={value} style={appendStyle} className="dFlex alignItemsCenter">
      <Style
        className={classes.radioBox}
        pseudo="checked:before"
        attr="background-color"
        color="#2c73e8"
      >
        <Style
          className={classes.radioBox}
          pseudo="checked"
          attr="border-color"
          color="#2c73e8"
        >
          <input
            className={classes.radioBox}
            type="radio"
            checked={isCheck}
            readOnly
            style={getStyle({ borderColor: '#9c9c9c' }, theme, typeFontSize)}
          />
        </Style>
      </Style>
      {title && (
        <Element
          elementName="span"
          style={{
            marginLeft: mlTitle,
            ...titleStyle,
            display: 'flex',
            alignItems: 'center',
            padding: '4px 12px',
            borderRadius: 4,
            color: '#9C9C9C',
            backgroundColor: '#FFFFFF',
            borderColor: '#E0E0E0',
            borderWidth: 1,
          }}
          className={isCheckOnClickText ? 'cursorPointer' : ''}
        >
          {!!endDate && !!startDate && isCheck ? (
            <span>
              <TextEllipsisStaticLine
                appendStyle={{ color: '#191d25' }}
                zIndexTooltip={7}
                lineClamp={1}
                text={`${startDate} > ${endDate}`}
              />
            </span>
          ) : (
            <Translate value={title} {...translateProps} />
          )}
          <Icon
            className="icon-calendar"
            style={{ fontSize: 16, marginLeft: 8 }}
          />
        </Element>
      )}
    </Element>
  )
}

RadioDateRangeCustom.propTypes = {
  title: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  isCheckOnClickText: PropTypes.bool,
  disabled: PropTypes.bool,
  appendStyle: PropTypes.object,
  mlTitle: PropTypes.number,
  titleStyle: PropTypes.object,
  translateProps: PropTypes.object,
}

RadioDateRangeCustom.defaultProps = {
  checked: false,
  isCheckOnClickText: true,
  disabled: false,
  mlTitle: 10,
  titleStyle: {},
  translateProps: {},
}
